<template>
  <v-navigation-drawer
    :value="value"
    @input="(value) => $emit('input', value)"
    app
    clipped
    width="22rem"
  >
    <v-list>
      <v-list-item link to="/">
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title> Главная страница </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group
        :value="true"
        prepend-icon="mdi-chart-line"
        color="success"
        no-action
      >
        <template v-slot:activator>
          <v-list-item-title><T>Статистика</T></v-list-item-title>
        </template>

        <v-list-item link to="/software">
          <v-list-item-content>
            <v-list-item-title> Количество экземпляров ПО </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/versionStatistics">
          <v-list-item-content>
            <v-list-item-title> Статистика версий </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/statistics/baseStatisticsSum">
          <v-list-item-content>
            <v-list-item-title> Базовые метрики (суммарно) </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/statistics/baseStatisticsDetail">
          <v-list-item-content>
            <v-list-item-title> Базовые метрики (детально) </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/statistics/businessStatisticsSum">
          <v-list-item-content>
            <v-list-item-title> Бизнес метрики (суммарно) </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/statistics/businessStatisticsDetail">
          <v-list-item-content>
            <v-list-item-title> Бизнес метрики (детально) </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/statistics/configurationData">
          <v-list-item-content>
            <v-list-item-title> Данные конфигурации </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-list-item link to="/maps">
        <v-list-item-action>
          <v-icon>mdi-map</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title> Карты </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item href="/docs" target="_blank">
        <v-list-item-action>
          <v-icon>mdi-text-box</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title> API документация </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link @click="logout">
        <v-list-item-action>
          <v-icon>mdi-export</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title> Выход </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-dialog v-model="dialog" max-width="300" style='z-index:999999;'>
      <v-card>
        <v-card-title class="headline">Подтверждение</v-card-title>
        <v-card-text>Вы уверены, что хотите выйти?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialog = false"
            >Отмена</v-btn
          >
          <v-btn color="green darken-1" text @click="confirmLogout"
            >Подтвердить</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      dialog: false,
    };
  },
  props: {
    value: { default: null },
  },
  methods: {
    ...mapActions(["logOut"]),
    async logout() {
      this.dialog = true;
    },
    async confirmLogout() {
      this.logOut();
      location.reload();
    },
  },
};
</script>
